import { render, staticRenderFns } from "./CardTitle.vue?vue&type=template&id=573a3330&scoped=true&"
import script from "./CardTitle.vue?vue&type=script&lang=ts&"
export * from "./CardTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573a3330",
  null
  
)

export default component.exports